import React from "react";
import ModalTemplate from "../modal-template";
import styled from "styled-components";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import { Link } from "react-router-dom";

interface IProps {
  heading: string;
  confirmText: string;
  close: () => void;
  confirm: () => void;
  linkText?: string;
  link?: string;
}
const SuccessModal = ({
  heading,
  confirmText,
  close,
  confirm,
  linkText,
  link
}: IProps) => {
  return (
    <ModalTemplate close={close} confirm={confirm} confirmText={confirmText}>
      <Body>
        <Typography weight="semibold" size="xl" mb="3.2">
          {heading}
        </Typography>
        <SucessIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 80 80"
            fill="none"
          >
            <path
              d="M44.8027 39.0816L42.9273 40.1505L29.8125 46.7078L38.1863 41.9341L38.724 41.6259L41.9895 39.7636L42.5273 39.4554L43.2748 39.0292C43.6814 38.7996 44.1731 38.8062 44.7567 39.0619C44.7698 39.0685 44.7895 39.0751 44.8027 39.0816Z"
              fill="#ADFF5B"
              stroke="#5AB400"
              stroke-width="1.31148"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M43.2305 47.7903L42.7124 48.0853L31.8665 54.2689L31.7157 54.3542C31.578 54.4329 31.4403 54.4853 31.2895 54.5181C30.8501 54.6165 30.3583 54.505 29.8141 54.1903C29.0928 53.7771 28.4567 53.1017 27.9124 52.1575L20.1616 38.7935C19.6632 37.9345 19.4141 37.0558 19.4141 36.1706C19.4141 35.2853 19.6632 34.7017 20.1616 34.4198C20.4042 34.2821 20.6796 34.2296 20.9944 34.2624C21.2108 34.2886 21.4468 34.3607 21.696 34.4788C21.8141 34.5247 21.9387 34.5903 22.0632 34.6624C22.837 35.1083 23.4731 35.7575 23.9649 36.6165L29.8141 46.7083L39.0075 42.1116L41.0272 45.6001C41.5714 46.5444 42.2075 47.2198 42.9288 47.6329C43.0337 47.6919 43.1321 47.7444 43.2305 47.7903Z"
              fill="#ADFF5B"
              stroke="#5AB400"
              stroke-width="1.31148"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M58.675 45.5807C58.1832 43.9873 57.6258 42.4135 57.0094 40.8594C57.0028 40.8463 57.0029 40.8397 56.9963 40.8266C56.0717 38.4791 54.9963 36.1971 53.7832 33.961C53.7832 33.9545 53.7832 33.9414 53.7701 33.9348C53.4816 33.3905 53.1799 32.8528 52.8652 32.3151C50.4127 28.0922 47.5405 24.2102 44.229 20.6627C40.9176 17.1151 37.3831 14.2496 33.6193 12.0791C29.8619 9.90858 26.3209 8.68235 23.0225 8.4135C22.8848 8.40038 22.7471 8.39383 22.616 8.38727C22.4914 8.37415 22.3734 8.3676 22.2488 8.36104C19.8094 8.25612 17.6258 8.62989 15.6848 9.44956L15.5734 9.50202C15.4619 9.54793 15.3635 9.58727 15.2652 9.63973L14.97 9.78399C14.7733 9.88235 14.57 9.99383 14.3864 10.0987C11.9339 11.4889 9.99956 13.6791 8.57006 16.6496C7.14055 19.6266 6.42578 23.266 6.42578 27.5807C6.42578 31.8955 7.14055 36.3676 8.57006 40.9905C9.99956 45.6135 11.9339 50.0332 14.3864 54.2561C16.8323 58.4725 19.7111 62.361 23.0225 65.9086C26.3209 69.4627 29.8619 72.3152 33.6193 74.4922C37.3831 76.6627 40.9176 77.889 44.229 78.1578C47.1536 78.3939 49.7438 77.9873 51.9996 76.9185L52.7209 76.5578C52.7668 76.525 52.8193 76.4988 52.8652 76.4726C54.7209 75.4168 56.2881 73.9021 57.5537 71.9283C57.6193 71.83 57.6848 71.7316 57.7373 71.6267C58.0783 71.089 58.3799 70.525 58.675 69.9218C60.1045 66.9447 60.8127 63.3053 60.8127 58.984C60.8127 54.6627 60.1045 50.1971 58.675 45.5807ZM47.0881 45.5938L43.2324 47.7905L42.7143 48.0856L31.8684 54.2692L31.7176 54.3545C31.5799 54.4332 31.4422 54.4856 31.2914 54.5184C30.852 54.6168 30.3602 54.5053 29.816 54.1905C29.0947 53.7774 28.4585 53.102 27.9143 52.1578L20.1635 38.7938C19.6652 37.9348 19.416 37.0561 19.416 36.1709C19.416 35.2856 19.6652 34.702 20.1635 34.4201C20.4061 34.2823 20.6816 34.2299 20.9963 34.2627C21.2127 34.2889 21.4488 34.361 21.6979 34.4791C21.816 34.525 21.9406 34.5905 22.0652 34.6627C22.8389 35.1086 23.475 35.7578 23.9668 36.6168L29.816 46.7086L38.1897 41.9348L38.7275 41.6266L41.993 39.7643L42.5307 39.4561L43.2783 39.0299C43.6848 38.8004 44.1766 38.8069 44.7602 39.0627C44.7733 39.0692 44.793 39.0758 44.8061 39.0823C44.9307 39.1348 45.0553 39.1938 45.1865 39.2725C45.9471 39.7184 46.5832 40.3676 47.0881 41.2266C47.5799 42.0922 47.8356 42.9578 47.8356 43.843C47.8356 44.7282 47.5799 45.3119 47.0881 45.5938Z"
              fill="#ADFF5B"
              stroke="#5AB400"
              stroke-width="1.31148"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M73.9261 52.4261C73.9261 56.7475 73.2179 60.3868 71.7884 63.3638C71.4408 64.0786 71.0736 64.7475 70.6671 65.3704C69.4016 67.3442 67.8344 68.859 65.9787 69.9147C65.9197 69.9475 65.8606 69.9803 65.8016 70.0197L65.1131 70.3606L52.7196 76.5574C52.7655 76.5246 52.818 76.4983 52.8639 76.4721C54.7197 75.4164 56.2868 73.9016 57.5524 71.9279C57.618 71.8295 57.6836 71.7311 57.7361 71.6262C58.077 71.0885 58.3787 70.5246 58.6738 69.9213C60.1033 66.9442 60.8115 63.3048 60.8115 58.9835C60.8115 54.6622 60.1033 50.1966 58.6738 45.5802C58.182 43.9868 57.6245 42.413 57.0081 40.8589C57.0016 40.8458 57.0016 40.8393 56.9951 40.8261C56.0705 38.4786 54.995 36.1966 53.7819 33.9606C53.7819 33.954 53.782 33.9409 53.7688 33.9343C53.4803 33.3901 53.1787 32.8524 52.8639 32.3147C50.4115 28.0917 47.5393 24.2098 44.2278 20.6622C40.9163 17.1147 37.3819 14.2491 33.618 12.0786C29.8606 9.90812 26.3197 8.68189 23.0213 8.41304C22.8836 8.39992 22.7459 8.39336 22.6147 8.38681C22.4902 8.37369 22.3721 8.36713 22.2475 8.36058C19.8082 8.25566 17.6246 8.62943 15.6836 9.4491L27.4999 3.54088C27.6835 3.43597 27.8868 3.32449 28.0835 3.22613L28.3787 3.08187C28.477 3.02941 28.5754 2.99007 28.6869 2.94416L28.7327 2.91793C30.6934 2.07859 32.8967 1.69826 35.3623 1.80318C35.618 1.81629 35.8738 1.83597 36.1361 1.85564C39.4344 2.12449 42.9753 3.35072 46.7327 5.52121C50.4966 7.69172 54.0311 10.5573 57.3425 14.1048C60.654 17.6524 63.5262 21.5343 65.9787 25.7573C66.2934 26.295 66.5951 26.8327 66.8836 27.377C68.1033 29.6196 69.1787 31.9147 70.1098 34.2688C70.7326 35.836 71.29 37.4163 71.7884 39.0229C73.2179 43.6393 73.9261 48.1048 73.9261 52.4261Z"
              fill="#ADFF5B"
              stroke="#5AB400"
              stroke-width="1.31148"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </SucessIcon>
        {linkText ? (
          <TextLink to={link || ""}>
            <Typography
              decoration="underline"
              color={Colors.yellow100}
              weight="medium"
            >
              {linkText}
            </Typography>
          </TextLink>
        ) : (
          ""
        )}
      </Body>
    </ModalTemplate>
  );
};

export default SuccessModal;

const Body = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 3.2rem 0;
  @media only screen and (max-width: 769px) {
    width: 40rem;
  }
`;

const SucessIcon = styled.div`
  width: 8rem;
  height: 8rem;
  margin-bottom: 3.2rem;
`;

const TextLink = styled(Link)`
  all: unset;
  cursor: pointer;
`;
